<template>
  <div class="colorations-games">
    <MenuGames :items="figures" :current="(currentFigure.name).toLowerCase().replace(/ /g, '')" @init="init"/>
    <Figure :currentFigure="currentFigure" :figures="figures" @init="init"/>
  </div>
</template>

<script>
import MenuGames from "../layout/MenuGames";
import figures from "./config/coloration.json";
import Figure from "./Figure.vue";
export default {
  name: "ColorationGames",
  components: {
    Figure,
    MenuGames
  },

  data: () => ({
    figures: figures.figures,
    currentFigure: figures.figures['figure1'],
  }),
  methods: {
    init(event) {
      this.currentFigure = figures.figures[event.param]
    }
  },
};
</script>

<style lang="scss">
.activeColoration {
  font-weight: bold;
  border: 2px solid #000 !important;
}
.colorations-games {
  margin-left: 10rem;
  &-menu ul {
    justify-content: space-between;
  }

  @media (max-width: 1300px) {
    margin-left: 3rem;
  }
  @media (max-width: 1200px) {
    margin-left: 0;
  }
}
</style>